/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';
import AuthLayout from './layouts/Auth';
import ErrorLayout from './layouts/Error';
import DashboardLayout from './layouts/Dashboard';

export default [
  {
    path: '/',
    exact: true,
    component: () => <Redirect to="/dashboard" />
  },
  {
    path: '/auth',
    component: AuthLayout,
    routes: [
      {
        path: '/auth/login',
        exact: true,
        component: lazy(() => import('src/views/Login'))
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  },
  {
    path: '/errors',
    component: ErrorLayout,
    routes: [
      {
        path: '/errors/error-401',
        exact: true,
        component: lazy(() => import('src/views/Error401'))
      },
      {
        path: '/errors/error-404',
        exact: true,
        component: lazy(() => import('src/views/Error404'))
      },
      {
        path: '/errors/error-500',
        exact: true,
        component: lazy(() => import('src/views/Error500'))
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  },
  {
    route: '*',
    component: DashboardLayout,
    routes: [
      {
        path: '/dashboard',
        exact: true,
        component: lazy(() => import('src/views/Calendar'))
      },
      {
        path: '/companies',
        exact: true,
        component: lazy(() => import('src/views/CompaniesManagementList'))
      },
      {
        path: '/companies/:id',
        exact: true,
        component: lazy(() => import('src/views/CompanyManagementDetails'))
      },
      {
        path: '/users/:id',
        exact: true,
        component: lazy(() => import('src/views/UserPage'))
      },
      {
        path: '/users/:id/:tab',
        exact: true,
        component: lazy(() => import('src/views/UserPage'))
      },
      {
        path: '/companies/:id/:tab',
        exact: true,
        component: lazy(() => import('src/views/CompanyManagementDetails'))
      },
      {
        path: '/companies/:companyUUID/machines/:machineUUID',
        exact: true,
        component: lazy(() =>
          import('src/views/MachineDetail/MachineDetailPage')
        )
      },
      {
        path: '/companies/:companyUUID/machines/:machineUUID/reports/new',
        exact: true,
        component: lazy(() =>
          import('src/views/MachineReports/CreateMachineReport')
        )
      },
      {
        path:
          '/companies/:companyUUID/machines/:machineUUID/reports/:reportUUID/edit',
        exact: true,
        component: lazy(() =>
          import('src/views/MachineReports/EditMachineReport')
        )
      },
      {
        path: '/companies/orders',
        exact: true,
        component: lazy(() => import('src/views/OrderManagementList'))
      },
      {
        path: '/approve-companies',
        exact: true,
        component: lazy(() => import('src/views/UnapprovedCompanies'))
      },
      {
        path: '/xero-contacts',
        exact: true,
        component: lazy(() => import('src/views/XeroContactLinking'))
      },
      {
        path: '/expiries',
        exact: true,
        component: lazy(() => import('src/views/Expiries'))
      },
      {
        path: '/management/orders/:id',
        exact: true,
        component: lazy(() => import('src/views/OrderManagementDetails'))
      },
      {
        path: '/categories',
        exact: true,
        component: lazy(() => import('src/views/CategoriesList'))
      },
      {
        path: '/secondarycategories',
        exact: true,
        component: lazy(() => import('src/views/SecondaryCategoriesList'))
      },
      {
        path: '/admins',
        exact: true,
        component: lazy(() => import('src/views/AdminsList'))
      },
      {
        path: '/admins/:id',
        exact: true,
        component: lazy(() => import('src/views/AdminDetails'))
      },
      {
        path: '/admins/:id/:tab',
        exact: true,
        component: lazy(() => import('src/views/AdminDetails'))
      },
      {
        path: '/assessmentRecord/:id',
        exact: true,
        component: lazy(() => import('src/views/AssessmentRecord'))
      },
      {
        path: '/assessmentRecord/:id/testRecord/:recordID',
        exact: true,
        component: lazy(() => import('src/views/AssessmentRecord/TestRecord'))
      },
      {
        path: '/news',
        exact: true,
        component: lazy(() => import('src/views/BlogsList'))
      },
      {
        path: '/blog/create/:tab',
        exact: true,
        component: lazy(() => import('src/views/Blog/CreateBlog'))
      },
      {
        path: '/blog/:id/:tab',
        exact: true,
        component: lazy(() => import('src/views/Blog/UpdateBlog'))
      },
      {
        path: '/notifications',
        exact: true,
        component: lazy(() => import('src/views/Notifications'))
      },
      {
        path: '/individuals',
        exact: true,
        component: lazy(() => import('src/views/IndividualsList'))
      },
      {
        path: '/individuals/:id',
        exact: true,
        component: lazy(() => import('src/views/IndividualDetails'))
      },
      {
        path: '/individuals/:id/:tab',
        exact: true,
        component: lazy(() => import('src/views/IndividualDetails'))
      },
      {
        path: '/delegates',
        exact: true,
        component: lazy(() => import('src/views/DelegatesList'))
      },
      {
        path: '/delegates/:id',
        exact: true,
        component: lazy(() => import('src/views/DelegateDetails'))
      },
      {
        path: '/delegates/:id/:tab',
        exact: true,
        component: lazy(() => import('src/views/DelegateDetails'))
      },
      {
        path: '/managers',
        exact: true,
        component: lazy(() => import('src/views/ManagersList'))
      },
      {
        path: '/managers/:id',
        exact: true,
        component: lazy(() => import('src/views/ManagerDetails'))
      },
      {
        path: '/managers/:id/:tab',
        exact: true,
        component: lazy(() => import('src/views/ManagerDetails'))
      },
      {
        path: '/tutors',
        exact: true,
        component: lazy(() => import('src/views/TutorsList'))
      },
      {
        path: '/tutor/create/:tab',
        exact: true,
        component: lazy(() => import('./views/Tutor/CreateTutor'))
      },
      {
        path: '/tutor/:ident/:tab',
        exact: true,
        component: lazy(() => import('./views/Tutor/UpdateTutor'))
      },
      {
        path: '/overview',
        exact: true,
        component: lazy(() => import('./views/Overview'))
      },
      {
        path: '/courses',
        exact: true,
        component: lazy(() => import('./views/CoursesView'))
      },
      {
        path: '/course/:ident/:tab',
        exact: true,
        component: lazy(() => import('./views/CreateCourse'))
      },
      {
        path: '/courses/create',
        exact: true,
        component: lazy(() => import('./views/CreateCourse'))
      },
      {
        path: '/courses/create/:tab',
        exact: true,
        component: lazy(() => import('./views/CreateCourse'))
      },
      {
        path: '/instance/create/:courseID',
        exact: true,
        component: lazy(() =>
          import('./views/CreateCourse/Instances/InstanceEdit')
        )
      },
      {
        path: '/instance/:ident',
        exact: true,
        component: lazy(() =>
          import('./views/CreateCourse/Instances/InstanceEdit')
        )
      },
      {
        path: '/tests',
        exact: true,
        component: lazy(() => import('./views/TestsList'))
      },
      {
        path: '/test/create/:tab',
        exact: true,
        component: lazy(() => import('./views/Test/CreateTest'))
      },
      {
        path: '/test/:ident/:tab',
        exact: true,
        component: lazy(() => import('./views/Test/UpdateTest'))
      },
      {
        path: '/modules',
        exact: true,
        component: lazy(() => import('./views/ModulesList'))
      },
      {
        path: '/modules/create/:tab',
        exact: true,
        component: lazy(() => import('./views/Module/CreateModule'))
      },
      {
        path: '/modules/:ident/:tab',
        exact: true,
        component: lazy(() => import('./views/Module/UpdateModule'))
      },
      {
        path: '/questions',
        exact: true,
        component: lazy(() => import('./views/QuestionsList'))
      },
      {
        path: '/questions/create/:tab',
        exact: true,
        component: lazy(() => import('./views/Question/CreateQuestion'))
      },
      {
        path: '/question/:ident/:tab',
        exact: true,
        component: lazy(() => import('./views/Question/UpdateQuestion'))
      },
      {
        path: '/lessons',
        exact: true,
        component: lazy(() => import('./views/LessonsList'))
      },
      {
        path: '/lessons/create/:tab',
        exact: true,
        component: lazy(() => import('./views/Lesson/CreateLesson'))
      },
      {
        path: '/lesson/:ident/:tab',
        exact: true,
        component: lazy(() => import('./views/Lesson/UpdateLesson'))
      },
      {
        path: '/certificateTypes',
        exact: true,
        component: lazy(() => import('./views/CertificateTypesList'))
      },
      {
        path: '/certificateTypes/create/:tab',
        exact: true,
        component: lazy(() =>
          import('./views/CertificateType/CreateCertificateType')
        )
      },
      {
        path: '/certificateTypes/:ident/:tab',
        exact: true,
        component: lazy(() =>
          import('./views/CertificateType/UpdateCertificateType')
        )
      },
      {
        path: '/caaNumbers',
        exact: true,
        component: lazy(() => import('./views/CAANumbersList'))
      },
      {
        path: '/caaNumber/:id/:tab',
        exact: true,
        component: lazy(() => import('src/views/CAANumberDetails'))
      },
      {
        path: '/popular-courses',
        exact: true,
        component: lazy(() => import('src/views/PopularCourses'))
      },
      {
        path: '/social-feed',
        exact: true,
        component: lazy(() => import('src/views/SocialFeed'))
      },
      {
        path: '/getting-started',
        exact: true,
        component: lazy(() => import('src/views/GettingStarted'))
      },
      {
        path: '/tags',
        exact: true,
        component: lazy(() => import('src/views/Tags'))
      },
      {
        path: '/audit-templates',
        exact: true,
        component: lazy(() => import('src/views/AuditTemplatesList'))
      },
      {
        path: '/audit-templates/:id',
        exact: true,
        component: lazy(() => import('src/views/AuditTemplate'))
      },
      {
        path: '/audit-templates/:id/:tab',
        exact: true,
        component: lazy(() => import('src/views/AuditTemplate'))
      },
      {
        path: '/createAudit/:templateId/:companyId',
        exact: true,
        component: lazy(() => import('src/views/CreateAudit'))
      },
      {
        path: '/editAudit/:auditId',
        exact: true,
        component: lazy(() => import('src/views/EditAudit'))
      },
      {
        path: '/background-checks',
        exact: true,
        component: lazy(() => import('src/views/BackgroundChecksList'))
      },
      {
        path: '/background-check/:id',
        exact: true,
        component: lazy(() => import('src/views/BackgroundCheck'))
      },
      {
        path: '/background-check-renewal/:id',
        exact: true,
        component: lazy(() => import('src/views/BackgroundCheck/Renewal'))
      },
      {
        path: '/background-check-verification/:id',
        exact: true,
        component: lazy(() =>
          import('src/views/BackgroundCheck/AutomaticVerification')
        )
      },
      {
        path: '/background-check-only-dbs/:id',
        exact: true,
        component: lazy(() =>
          import('src/views/BackgroundCheck/OnlyDBS')
        )
      },
      {
        path: '/simulator',
        exact: true,
        component: lazy(() => import('src/views/Simulator'))
      },
      {
        path: '/simulator/:tab',
        exact: true,
        component: lazy(() => import('src/views/Simulator'))
      },
      {
        path: '/simulator/xray/:id',
        exact: true,
        component: lazy(() => import('src/views/Simulator/NormalXray'))
      },
      {
        path: '/simulator/threat/:id',
        exact: true,
        component: lazy(() => import('src/views/Simulator/Threat'))
      },
      {
        path: '/certificate/:historicalCourseUUID',
        exact: true,
        component: lazy(() => import('src/views/Certificate'))
      },
      {
        path: '/syllabuses',
        exact: true,
        component: lazy(() => import('src/views/Syllabuses'))
      },
      {
        path: '/syllabus/:fileUUID',
        exact: true,
        component: lazy(() => import('src/views/Syllabuses/Syllabus'))
      },
      {
        path: '/qaf/observations',
        exact: true,
        component: lazy(() => import('src/views/Observations'))
      },
      {
        path: '/qaf/certQA',
        exact: true,
        component: lazy(() => import('src/views/CertQA'))
      },
      {
        path: '/qaf/certQA/:monthID',
        exact: true,
        component: lazy(() => import('src/views/CertQA/CertQAMonth'))
      },
      {
        path: '/qaf/classroomQA',
        exact: true,
        component: lazy(() => import('src/views/ClassroomQA'))
      },
      {
        path: '/qaf/classroomQA/:monthID',
        exact: true,
        component: lazy(() => import('src/views/ClassroomQA/ClassroomQAMonth'))
      },
      {
        path: '/qaf/course-logs',
        exact: true,
        component: lazy(() => import('src/views/CourseLogs'))
      },
      {
        path: '/sent-emails',
        exact: true,
        component: lazy(() => import('src/views/SentEmailsList'))
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  }
];
